import { PokeData } from "../../components/pokemon-data"

export const PagePokeDetails = () => (
    <PokeData/>
)